import * as React from 'react';
import { numberFormatter } from '../generics';
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ProductTableDataRange = function ProductTableDataRange(_ref) {
  var from = _ref.from,
      to = _ref.to,
      unit = _ref.unit;
  return _jsxs("div", {
    children: [numberFormatter(from, unit), _jsxs("span", {
      sx: {
        fontSize: ['xs', 'md']
      },
      children: [' ', "to ", numberFormatter(to, unit)]
    })]
  });
};

var PlainProductTableDataRange = function PlainProductTableDataRange(props) {
  var from = props.from,
      to = props.to,
      unit = props.unit;
  return "".concat(numberFormatter(from, unit), " to ").concat(numberFormatter(to, unit));
};

export default ProductTableDataRange;
export var Rich = ProductTableDataRange;
export var Plain = PlainProductTableDataRange;
//# sourceMappingURL=data-range.js.map